import Vue from 'vue'
import Router from 'vue-router'
import homes from '@/pages/home'
import kaimgr from '@/pages/kaimgr'
import login from '@/components/login'
import cate from '@/pages/cate'
import lotto from '@/pages/lotto'
import keep from '@/pages/keep'
import six from '@/pages/six'
import news from '@/pages/news'
import video from '@/pages/video'
// import videopassword from '@/pages/videopassword'
import home from '@/pages/lunbo'
import user from '@/pages/user'
import kaisix from '@/pages/kaisix'
import kaijnd from '@/pages/kaijnd'
import kaijndx from '@/pages/kaijndx'
import kaibinguo from '@/pages/kaibinguo'
import kaibit from '@/pages/kaibit'
import error from '@/components/404'

Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      name: 'homes',
      component: homes,
      children: [
        {
          path: '',
          component: login
        },
        {
          path: 'login',
		  name: 'login',
          component: login
        }
      ]
    },
    {
      path: '/kaimgr',
      component: kaimgr,
      children: [
        {
          path: 'home',
          component: home,
          meta: { auth: true }
        },
        {
          path: 'cate',
          component: cate,
          meta: { auth: true }
        },
        {
          path: 'user',
          component: user,
          meta: { auth: true }
        },
        {
          path: 'lotto',
          component: lotto,
          meta: { auth: true }
        },
        {
          path: 'keep',
          component: keep,
          meta: { auth: true }
        },
        {
          path: 'kaisix',
          component: kaisix,
          meta: { auth: true }
        },
        {
          path: 'kaijnd',
          component: kaijnd,
          meta: { auth: true }
        },
        {
          path: 'kaijndx',
          component: kaijndx,
          meta: { auth: true }
        },
        {
          path: 'kaibinguo',
          component: kaibinguo,
          meta: { auth: true }
        },
        {
          path: 'kaibit',
          component: kaibit,
          meta: { auth: true }
        },
        {
          path: 'six',
          component: six,
          meta: { auth: true }
        },
        {
          path: 'news',
          component: news,
          meta: { auth: true }
        },
        {
          path: 'video',
          component: video,
          meta: { auth: true }
        },
		// {
		//   path: 'videopassword',
		//   component: videopassword,
		//   meta: { auth: true }
		// },
        {
          path: '*',
          component: error
        }
      ]
    },
    {
      path: '*',
      component: error
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js